import {Entry} from '../model/entry.model';
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class EntryIncreasedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(readonly entry: Entry) {
  }
}
